import { CImg } from "@coreui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/ZeroBees_logo_new.svg";

const NoDataWarning = ({ text, className, explanation, showLogo = false }) => {
  const { t } = useTranslation();

  let msg = text || t("summary.noResults");

  return (
    <div className={`d-flex flex-column align-items-center ${className}`}>
      {showLogo && <CImg src={logo} alt="zerobees's logo" width="200px" />}
      <h2 className={`text-primary `}>{msg}</h2>
      <h5 className="text-info">{explanation}</h5>
    </div>
  );
};

export default NoDataWarning;
